import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';
import { getSlotImage, getTab } from './MascotUtils';

class Converter implements ISlotConverter {
  convertGameList = ({
    data,
  }: IConvertGameList<{
    Games?: Array<{
      Id: string;
      Description: string;
      Format: string;
      Name: string;
      SectionId: string;
    }>;
  }>): ISlotViewItem[] =>
    (data?.Games ?? []).map(item => ({
      id: item.Id,
      gameId: item.Id,
      description: item.Description,
      format: item.Format,
      gameName: item.Name,
      sectionId: item.SectionId,
      tab: getTab(item.Id, item.Name),
      provider: 'mascot',
      imageUrl: getSlotImage(item.Id, item.SectionId),
      routeProvider: 'mascot',
      type: CasinoType.slots,
    }));

  convertGameUrl = ({ data }: IGetGameUrl<{ SessionUrl: string }, unknown>) => data.SessionUrl;
}

export default Converter;
